import React, { useState, useRef, useEffect } from 'react';
import dinde from '../Assets/dinde.webp'
import nugget from '../Assets/nugget.webp'
import poulet from '../Assets/poulet.webp'
import cataloguedinde from '../Assets/pdfs/cataloguedinde_foodlink.pdf'
import cataloguenugget from '../Assets/pdfs/cataloguenuggets_foodlink.pdf'
import cataloguepoulet from '../Assets/pdfs/cataloguepoulet_foodlink.pdf'
import HeadingOfSection from './HeadingOfSection';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

const ProductSection = ({isMob}) => {
    const {t, i18n} = useTranslation();
    const isRTL = i18n.language === 'ar';
    const [searchParams, setSearchParams] = useSearchParams();
    const productId = searchParams.get('product');

    const [activeCategory, setActiveCategory] = useState('all');
    const [selectedProductId, setSelectedProductId] = useState(productId);
    const scrollContainerRef = useRef(null);
    const activeButtonRef = useRef(null);

    const products = [
        {
            id: 1,
            title: 'CATALOGUE FOODLINK DINDE',
            image: dinde,
            category: 'dinde',
            pdfUrl: cataloguedinde,
            price : '350' , currency : t('productpage.currency') , unit_with : t('productpage.unit_with')
        },
        {
            id: 2,
            title: 'CATALOGUE FOODLINK POULET',
            image: poulet,
            category: 'poulet',
            pdfUrl: cataloguepoulet,
            price : '350' , currency : t('productpage.currency') , unit_with : t('productpage.unit_with')
        },
        {
            id: 3,
            title: 'FOODLINK CATALOGUE NUGGETS ET FRITES SURGELES 7/7',
            image: nugget,
            category: 'nuggets',
            pdfUrl: cataloguenugget,
            price : '350' , currency : t('productpage.currency') , unit_with : t('productpage.unit_with')
        }
    ];

    useEffect(() => {
        if (productId) {
            setSelectedProductId(productId);
            const product = products.find(p => p.id === parseInt(productId));
            if (product) {
                setActiveCategory(product.category);
                // Scroll to active button after a short delay to ensure DOM is updated
                setTimeout(() => {
                    if (activeButtonRef.current && scrollContainerRef.current) {
                        const container = scrollContainerRef.current;
                        const button = activeButtonRef.current;
                        const containerWidth = container.offsetWidth;
                        const buttonLeft = button.offsetLeft;
                        const buttonWidth = button.offsetWidth;
                        
                        // Calculate scroll position to center the button
                        const scrollPosition = buttonLeft - (containerWidth / 2) + (buttonWidth / 2);
                        container.scrollTo({
                            left: scrollPosition,
                            behavior: 'smooth'
                        });
                    }
                }, 100);
            }
        }
    }, [productId]);

    const filterProducts = (category) => {
        setActiveCategory(category);
        setSelectedProductId(null);
        // Remove the product parameter from URL when filtering
        if (searchParams.has('product')) {
            searchParams.delete('product');
            setSearchParams(searchParams);
        }
    };

    const getFilteredProducts = () => {
        if (selectedProductId) {
            return products.filter(product => product.id === parseInt(selectedProductId));
        }
        return activeCategory === 'all' 
            ? products 
            : products.filter(product => product.category === activeCategory);
    };

    const filteredProducts = getFilteredProducts();

    const handleWheel = (e) => {
        if (isMob && scrollContainerRef.current) {
            e.preventDefault();
            const delta = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
            const scrollAmount = delta > 0 ? 100 : -100;
            scrollContainerRef.current.scrollBy({
                left: scrollAmount,
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (isMob && scrollContainer) {
            scrollContainer.addEventListener('wheel', handleWheel, { passive: false });
            return () => scrollContainer.removeEventListener('wheel', handleWheel);
        }
    }, [isMob]);

  return (
    <div className={`px-6 sm:px-10 lg:px-24 xl:px-32 xxl:px-40 xxxl:px-52 ${isRTL ? 'font-almarai rtl' : 'font-inter ltr'} w-full mt-16 md:mt-10 overflow-hidden`}>
            <HeadingOfSection 
                header={t('productpage.title')}
                span={t('productpage.span')}/>
            {/* Filter Buttons */}
            <div 
                ref={scrollContainerRef}
                className={`flex gap-4 rounded-lg mb-4 sm:mb-8  ${isMob ? 'overflow-x-auto whitespace-nowrap hide-scrollbar  justify-start' : 'overflow-x-auto whitespace-nowrap hide-scrollbar justify-center'}`}
                style={{ scrollBehavior: 'smooth', msOverflowStyle: 'none', scrollbarWidth: 'none' }}
            >
                <button 
                    onClick={() => filterProducts('all')}
                    ref={activeCategory === 'all' ? activeButtonRef : null}
                    className={`px-6 py-2 rounded-lg outline-none text-lg md:text-xl xxl:text-2xl flex-shrink-0 ${activeCategory === 'all' ? 'bg-primary text-white font-bold' : 'bg-[#F9ECEC] font-normal text-[#826464]'}`}
                >
                    {t('productpage.filterbuttons.all')}
                </button>
                <button 
                    onClick={() => filterProducts('dinde')}
                    ref={activeCategory === 'dinde' ? activeButtonRef : null}
                    className={`px-6 py-2 rounded-lg outline-none text-lg md:text-xl xxl:text-2xl flex-shrink-0 ${activeCategory === 'dinde' ? 'bg-primary text-white font-bold' : 'bg-[#F9ECEC] font-normal text-[#826464]'}`}
                >
                    {t('productpage.filterbuttons.dinde')}
                </button>
                <button 
                    onClick={() => filterProducts('poulet')}
                    ref={activeCategory === 'poulet' ? activeButtonRef : null}
                    className={`px-6 py-2 rounded-lg outline-none text-lg md:text-xl xxl:text-2xl flex-shrink-0 ${activeCategory === 'poulet' ? 'bg-primary text-white font-bold' : 'bg-[#F9ECEC] font-normal text-[#826464]'}`}
                >
                    {t('productpage.filterbuttons.poulet')}
                </button>
                <button 
                    onClick={() => filterProducts('nuggets')}
                    ref={activeCategory === 'nuggets' ? activeButtonRef : null}
                    className={`px-6 py-2 rounded-lg outline-none text-lg md:text-xl xxl:text-2xl flex-shrink-0 ${activeCategory === 'nuggets' ? 'bg-primary text-white font-bold' : 'bg-[#F9ECEC] font-normal text-[#826464]'}`}
                >
                    {t('productpage.filterbuttons.nugget')}
                </button>
            </div>

            {/* Product Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 lg:gap-6 xl:gap-12 py-2 sm:py-4">
                {filteredProducts.map((product) => (
                    <a href={product.pdfUrl} target="_blank" rel="noopener noreferrer" key={product.id} className="bg-white rounded-2xl overflow-hidden shadow-md sm:shadow-lg aspect-[290/460]" >
                        <div className="relative w-full h-[80%]">
                            <img 
                                loading="lazy"
                                src={product.image} 
                                alt={product.title}
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="p-6 flex flex-col justify-center gap-2 sm:gap-4 lg:gap-3 xl:gap-4 items-center h-[20%] bg-[#F7F5F0]">
                            <h3 className="text-xl xs:text-2xl sm:text-4xl lg:text-lg xl:text-xl xxl:text-2xl xxxl:text-3xl xxxxl:text-4xl font-semibold text-center h-[50%] flex items-center text-primary">
                                {/* {isRTL ? `${product.price} ${product.currency} ${product.unit_with}` : `${product.price}.${product.currency},${product.unit_with}`} */}
                            </h3>
                            <a 
                                href={product.pdfUrl}
                                download={product.title}
                                className="block w-full bg-secondary text-white text-center text-lg sm:text-2xl md:text-xl xl:text-2xl font-bold py-2 xl:py-3 rounded-md hover:bg-secondary/90 transition-colors"
                            >
                                {t('productpage.button')}
                            </a>
                        </div>
                    </a>
                ))}
            </div>
        </div>
  )
}

export default ProductSection